function showAlert(message) {
    document.getElementById("alertText").innerText = message;
    document.getElementById("alertPopup").style.display = "block";
    document.getElementById("alertOverlay").style.display = "block";
}

function closeAlert() {
    document.getElementById("alertPopup").style.display = "none";
    document.getElementById("alertOverlay").style.display = "none";
}

document.querySelectorAll(".btn-next-step").forEach( (btn, index, array) => {
  btn.addEventListener("click", () => {
    let active = document.querySelector(".tab-content.active");
    let form = document.querySelector("#contact_form");
    let searchParams = {}
    if(!!window.location.search){
        let searchParams = window.location.search.split("?")[1].split("&").reduce((acc,p) => {
        const [k,v] = p.split("=");
        if(k.toUpperCase() === "GCLID"){
          acc[k.toUpperCase()] = v;
        } else {
          acc[k] = v;  
        }
        return acc;
      }, {})   
    }
  

    if (index === array.length - 1) {
      btn.textContent = "Processing...";
    }

    if (!form) {
      console.error("Form not found!");
      return;
    }

    let startZip = active.querySelector("input#starting-zip-code");
    let endZip = active.querySelector("input#ending-zip-code");
    let selectField = active.querySelector("select#move-type");
    let dateField = active.querySelector("input#move-date");
    let firstName = active.querySelector("input#first-name");
    let lastName = active.querySelector("input#last-name");
    let email = active.querySelector("input#email");
    let phone = active.querySelector("input#phone");

    let isValid = true;
    let errorMessage = "";

    if (startZip && !startZip.value.trim()) {
      isValid = false;
      errorMessage = "Please enter the starting zip code.";
    } else if (startZip && !/^\d{5}$/.test(startZip.value.trim())) {
      isValid = false;
      errorMessage = "Starting zip code must be exactly 5 digits.";
    } else if (endZip && !endZip.value.trim()) {
      isValid = false;
      errorMessage = "Please enter the ending zip code.";
    } else if (endZip && !/^\d{5}$/.test(endZip.value.trim())) {
      isValid = false;
      errorMessage = "Ending zip code must be exactly 5 digits.";
    } else if (selectField && !selectField.value.trim()) {
      isValid = false;
      errorMessage = "Please select an option.";
    } else if (dateField && !dateField.value.trim()) {
      isValid = false;
      errorMessage = "Please enter a valid date.";
    } else if (firstName && !firstName.value.trim()) {
      isValid = false;
      errorMessage = "First name must have at least 2 characters.";
      btn.textContent = "Submit";
    } else if (lastName && !lastName.value.trim()) {
      isValid = false;
      errorMessage = "Last name must have at least 2 characters.";
      btn.textContent = "Submit";
    } else if (email && !email.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      isValid = false;
      errorMessage = "Please enter a valid email address.";
      btn.textContent = "Submit";
    } else if (phone && !phone.value.trim() && !/^\d{10,}$/.test(phone)) {
      isValid = false;
      btn.textContent = "Submit";
      errorMessage = "Phone number must be at least 10 digits.";
      btn.textContent = "Submit";
    }

    if (isValid) {
      let nextTab = active.nextElementSibling;
      if (nextTab?.classList.contains("tab-content")) {
        active.classList.remove("active");
        nextTab.classList.add("active");
      } else {
        const contactForm = document.getElementById('contact_form');
        let startZip = contactForm.querySelector("input#starting-zip-code");
        let endZip = contactForm.querySelector("input#ending-zip-code");
        let selectField = contactForm.querySelector("select#move-type");
        let dateField = contactForm.querySelector("input#move-date");
        let firstName = contactForm.querySelector("input#first-name");
        let lastName = contactForm.querySelector("input#last-name");
        let email = contactForm.querySelector("input#email");
        let phone = contactForm.querySelector("input#phone");

        const formData = {
          "records": [
            {
              "fields": {
                "First Name": firstName.value.trim(),
                "Last Name": lastName.value.trim(),
                "Phone": phone.value.trim(),
                "Email": email.value.trim(),
                "Starting Zip Code": startZip.value.trim(),
                "Ending Zip Code": endZip.value.trim(),
                "Service Date": dateField.value.trim(),
                "Service Type": selectField.value.trim(),
                "Source": ["recdYI1JGIiGht3Ec"]
              }
            }
          ]
        };

        fetch("https://api.airtable.com/v0/appXSN5X0ze6O88lZ/Leads", {
          method: "POST",
          headers: {
            "Authorization": "Bearer patmdYf8rgwlzJ7Cs.0fa31776062077b2bf948a9cd9ac98679d07514c02da50ca1629a77ea59d1e40",
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
          console.log('data',data)
          if (data.error) {
            btn.textContent = "Submit";
            showAlert(data.error.message);
          } else {
            btn.textContent = "Submit";
            document.querySelector('.contact-form-status').style.display = 'block';
            document.querySelector('.tab-content.cstm-cf-field.active').classList.remove('active');
            console.log("DATA FROM LEAD", data);
            console.log("DATA records", data.records);
            console.log("FIRST RECORD", data.records[0]);
            console.log("THE ID", data.records[0].id);
            const leadId = data.records[0].id;
            console.log("lead ID", leadId);
            const timestamp = Date.now();
            const date = new Date(timestamp);
            const isoString = date.toISOString();
            if(Object.keys(searchParams).length !== 0 ){
                    fetch("https://api.airtable.com/v0/appXSN5X0ze6O88lZ/Google%20Ads%20Data", {
              method: "POST",
              headers: {
                "Authorization": "Bearer patmdYf8rgwlzJ7Cs.0fa31776062077b2bf948a9cd9ac98679d07514c02da50ca1629a77ea59d1e40",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                "records": [
                  {
                  "fields": { 
                    ...searchParams, 
                    "Timestamp": isoString ,
                    "Lead": [leadId] 
                  }
                }
              ]
            })
            }).then((data) => {
              console.log(data);
            });
            }
           // document.querySelector('.btn-submit').click();
          }
        })
        .catch(error => {
          console.error("Error:", error);
          btn.textContent = "Submit";
          showAlert(error.message);
        });
      }
    } else {
      showAlert(errorMessage);
    }
  });
});

function enforceMinMax(el) {
  if (el.value != "") {
    el.value = el.value.slice(0,5);
  }
}

function reorderArray(arr, order) {
    return order.map(index => arr[index]);
}


const dateInput = document.getElementById("move-date");
dateInput.addEventListener("change", function () {
  if (this.value) {
  console.log('this.value 1',this.value)
    // this.placeholder = this.value.split('-').reverse().join('/');
    let result = reorderArray(this.value.split('-'), [1, 2, 0]);
    this.placeholder = result.join('/');
console.log('---',result.join('/'))
        setTimeout(() => {
   // this.value = result.join('-');
    console.log('this.value',this.value)
}, 50);

    this.classList.remove('no_date');
  }
});
